import { render, staticRenderFns } from "./ConsolidarPagamentos.vue?vue&type=template&id=8730b19e&"
import script from "./ConsolidarPagamentos.vue?vue&type=script&lang=js&"
export * from "./ConsolidarPagamentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports